'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _modifiers = require('../../../modifiers');

var _modifiers2 = _interopRequireDefault(_modifiers);

var _constants = require('../../../constants');

var _constants2 = _interopRequireDefault(_constants);

var _element = require('../../element');

var _element2 = _interopRequireDefault(_element);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var colors = [null].concat(Object.keys(_constants2.default.COLORS).map(function (key) {
  return _constants2.default.COLORS[key];
}));

var Input = function (_React$PureComponent) {
  _inherits(Input, _React$PureComponent);

  function Input() {
    _classCallCheck(this, Input);

    return _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).apply(this, arguments));
  }

  _createClass(Input, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          type = _props.type,
          size = _props.size,
          color = _props.color,
          readOnly = _props.readOnly,
          isStatic = _props.isStatic,
          disabled = _props.disabled,
          placeholder = _props.placeholder,
          value = _props.value,
          name = _props.name,
          props = _objectWithoutProperties(_props, ['className', 'type', 'size', 'color', 'readOnly', 'isStatic', 'disabled', 'placeholder', 'value', 'name']);

      return _react2.default.createElement(_element2.default, _extends({}, props, {
        renderAs: 'input',
        name: name,
        value: value,
        type: type,
        placeholder: placeholder,
        readOnly: readOnly || isStatic,
        disabled: disabled,
        className: (0, _classnames3.default)('input', className, (_classnames = {
          'is-static': isStatic
        }, _defineProperty(_classnames, 'is-' + size, size), _defineProperty(_classnames, 'is-' + color, color), _classnames))
      }));
    }
  }]);

  return Input;
}(_react2.default.PureComponent);

Input.propTypes = _extends({}, _modifiers2.default.propTypes, {
  className: _propTypes2.default.string,
  style: _propTypes2.default.shape({}),
  type: _propTypes2.default.oneOf(['text', 'email', 'tel', 'password', 'number', 'search', 'color', 'date', 'time']),
  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  color: _propTypes2.default.oneOf(colors),
  readOnly: _propTypes2.default.bool,
  isStatic: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  placeholder: _propTypes2.default.string,
  value: _propTypes2.default.string,

  /**
   * The name of the input field Commonly used for [multi-input handling](https://reactjs.org/docs/forms.html#handling-multiple-inputs)
   */
  name: _propTypes2.default.string
});
Input.defaultProps = _extends({}, _modifiers2.default.defaultProps, {
  className: '',
  value: '',
  style: {},
  type: 'text',
  size: null,
  color: null,
  readOnly: false,
  isStatic: false,
  disabled: false,
  placeholder: '',
  name: null
});
exports.default = Input;